import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from './not-found/not-found.component';

// *******************************************************************************
// Layouts

import { Layout2Component } from './layout/layout-2/layout-2.component';
import { Layout2FlexComponent } from './layout/layout-2-flex/layout-2-flex.component';
import { LayoutBlankComponent } from './layout/layout-blank/layout-blank.component';
import { TotemModule } from './totem/totem.module'
import { LayoutBlankTotemComponent } from './layout/layout-blank-totem/layout-blank-totem.component';


// *******************************************************************************
// Routes

/* tslint:disable */
const routes: Routes = [
  // Default
  //{ path: '', redirectTo: 'search', pathMatch: 'full' },
  { path: '', redirectTo: 'login', pathMatch: 'full' },

  // Search
  { path: 'search', component: Layout2Component, loadChildren: () => import('./search/search.module').then(m => m.SearchModule) },

  // People
  { path: 'people', component: Layout2Component, loadChildren: () => import('./people/people.module').then(m => m.PeopleModule) },

  // People
  { path: 'stock', component: Layout2Component, loadChildren: () => import('./stock/stock.module').then(m => m.StockModule) },

  // Configuracoes
  { path: 'config', component: Layout2Component, loadChildren: () => import('./config/config.module').then(m => m.ConfigModule) },

  // Reservas
  { path: 'reservation', component: Layout2Component, loadChildren: () => import('./reservation/reservation.module').then(m => m.AreaReservationModule) },

  // Relatorios
  { path: 'reports', component: Layout2Component, loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule) },

  // pages
  { path: 'pages', component: Layout2FlexComponent, loadChildren: () => import('./+pages/pages.module').then(m => m.PagesModule) },

  // Login
  { path: 'login', component: LayoutBlankComponent, loadChildren: () => import('./login/login-blank.module').then(m => m.LoginBlankModule) },

  { path: 'dashboards', component: Layout2Component, loadChildren: () => import('./+dashboards/dashboards.module').then(m => m.DashboardsModule) },
  { path: 'layouts', loadChildren: () => import('./+layouts/layouts.module').then(m => m.LayoutsModule) },

  // Communication
  { path: 'communication', component: Layout2Component, loadChildren: () => import('./communication/communication.module').then(m => m.CommunicationModule) },

  // Help
  { path: 'help', component: Layout2Component, loadChildren: () => import('./help/help.module').then(m => m.HelpModule) },

  // Area Reservation
  { path: 'area-reservation', component: Layout2Component, loadChildren: () => import('./reservation/reservation.module').then(m => m.AreaReservationModule) },

  // Totem
  { path: 'totem', component: LayoutBlankComponent, loadChildren: () => import('./totem/totem.module').then(m => m.TotemModule) },


  // 404 Not Found page
  { path: '**', component: NotFoundComponent }
];
/* tslint:enable */

// *******************************************************************************
//
// https://stackoverflow.com/questions/50907736/refreshing-the-page-results-in-404-error-angular-6
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
